import { ReactNode, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";

// FE-N (#84fcb586) — three-level collapsible nesting in the precompiled
// progression form. Persistence is in-memory only (per-component useState),
// not URL/localStorage. `level` drives a CSS class so the surrounding stack
// can render different indents/borders without prop-drilling style overrides.
interface CollapsibleSectionProps {
  title: ReactNode;
  defaultOpen?: boolean;
  level?: 1 | 2 | 3;
  icon?: IconDefinition;
  className?: string;
  children: ReactNode;
}

export default function CollapsibleSection({
  title,
  defaultOpen = true,
  level = 1,
  icon,
  className,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState<boolean>(defaultOpen);
  const cls = ["pp-collapsible", `pp-collapsible-l${level}`];
  if (open) cls.push("open");
  if (className) cls.push(className);
  return (
    <div className={cls.join(" ")}>
      <button
        type="button"
        className="pp-collapsible-header"
        onClick={() => setOpen((p) => !p)}
        aria-expanded={open}
      >
        <span className="pp-collapsible-title">
          {icon && <FontAwesomeIcon icon={icon} className="me-1" />}
          {title}
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`pp-collapsible-chevron${open ? " open" : ""}`}
        />
      </button>
      {open && <div className="pp-collapsible-body">{children}</div>}
    </div>
  );
}
